import { CMS, GetFaqResponse } from "types/cms";
import { END_POINTS } from "../helpers";
import { Category, CommonBody, FaqRes } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const categoryApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCategory: builder.query<
      CommonResponse & { data: Category },
      { page: number; search: string }
    >({
      query: ({ page, search }) => ({
        url: `${END_POINTS.category}?page=${page}&search=${search}`,
        method: "GET",
      }),
    }),

    addCategory: builder.mutation<
      CommonResponse & { data: Category },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.category,
        method: "POST",
        body,
      }),
    }),

    categoryDetail: builder.query<
      CommonResponse & { data: Category },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "GET",
      }),
    }),

    updateCategory: builder.mutation<
      CommonResponse & { data: Category },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteCategory: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "DELETE",
      }),
    }),

    categoryStatus: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "PATCH",
      }),
    }),

    getAllBrands: builder.query<
      CommonResponse & { data: Category },
      { page: number; search: string }
    >({
      query: ({ page, search }) => ({
        url: `${END_POINTS.brands}?page=${page}&search=${search}`,
        method: "GET",
      }),
    }),

    addBrand: builder.mutation<
      CommonResponse & { data: Category },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addBrand,
        method: "POST",
        body,
      }),
    }),

    brandDetail: builder.query<
      CommonResponse & { data: Category },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.brands}/${id}`,
        method: "GET",
      }),
    }),

    updateBrand: builder.mutation<
      CommonResponse & { data: Category },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.brands}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteBrand: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.brands}/${id}`,
        method: "DELETE",
      }),
    }),

    brandStatus: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.brands}/${id}`,
        method: "PATCH",
      }),
    }),

    getAllClasses: builder.query<
      CommonResponse & { data: Category },
      { page: number; search: string }
    >({
      query: ({ page, search }) => ({
        url: `${END_POINTS.class}?page=${page}&search=${search}`,
        method: "GET",
      }),
    }),

    addClass: builder.mutation<
      CommonResponse & { data: Category },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addClass,
        method: "POST",
        body,
      }),
    }),

    classDetail: builder.query<
      CommonResponse & { data: Category },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.class}/${id}`,
        method: "GET",
      }),
    }),

    updateClass: builder.mutation<
      CommonResponse & { data: Category },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.class}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteClass: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.class}/${id}`,
        method: "DELETE",
      }),
    }),

    classStatus: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.class}/${id}`,
        method: "PATCH",
      }),
    }),
  }),
});

export const {
  useLazyGetAllCategoryQuery,
  useAddCategoryMutation,
  useLazyCategoryDetailQuery,
  useUpdateCategoryMutation,
  useLazyDeleteCategoryQuery,
  useLazyCategoryStatusQuery,
  useLazyGetAllBrandsQuery,
  useAddBrandMutation,
  useLazyBrandDetailQuery,
  useUpdateBrandMutation,
  useLazyDeleteBrandQuery,
  useLazyBrandStatusQuery,
  useLazyGetAllClassesQuery,
  useLazyClassDetailQuery,
  useAddClassMutation,
  useUpdateClassMutation,
  useLazyClassStatusQuery,
  useLazyDeleteClassQuery,
} = categoryApi;
